import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function AccountLoginForm(props)
{
    var { t } = useTranslation();
    var navigate = useNavigate();

    async function onFormSubmit(event)
    {
        event.preventDefault();

        var loginInput = document.getElementById("loginIdentifier");
        var passwordInput = document.getElementById("loginPassword");

        if (!loginInput || !passwordInput)
        {
            return;
        }

        var loginValue = loginInput.value.trim();
        var passwordValue = passwordInput.value.trim();

        if (loginValue.length === 0 || passwordValue.length === 0)
        {
            window.UIkit.notification({
                message: "Fail: empty fields",
                status: "danger",
                pos: "bottom-right",
                timeout: 5000
            });
            return;
        }

        try
        {
            var response = await fetch("https://api.jai.com.kz/api/auth",
            {
                method: "POST",
                headers:
                {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    login: loginValue,
                    password: passwordValue
                })
            });

            var data = await response.json();
            console.log(data);

            if (!response.ok)
            {
                var errorMessage = data && data.error ? data.error : "Unknown error";
                window.UIkit.notification({
                    message: "Fail: " + errorMessage,
                    status: "danger",
                    pos: "bottom-right",
                    timeout: 5000
                });
                return;
            }

            if (data && data.token && data.userId)
            {
                localStorage.setItem("token", data.token);
                localStorage.setItem("userId", data.userId);

                window.UIkit.notification({
                    message: "Authorized",
                    status: "success",
                    pos: "bottom-right",
                    timeout: 5000
                });

                setTimeout(function redirectAfterSuccess()
                {
                    navigate("/form-submissions");
                }, 5000);
            }
            else
            {
                window.UIkit.notification({
                    message: "Fail: invalid server response",
                    status: "danger",
                    pos: "bottom-right",
                    timeout: 5000
                });
            }
        }
        catch (error)
        {
            window.UIkit.notification({
                message: "Fail: " + error.message,
                status: "danger",
                pos: "bottom-right",
                timeout: 5000
            });
        }
    }

    return (
        <div className="uk-container uk-margin-large-top uk-flex uk-flex-center">
            <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-width-1-2@m">
                <h1 className="uk-text-center uk-margin-large-bottom">
                    {t("ui.account.auth")}
                </h1>

                <form
                    className="uk-form-stacked uk-text-center"
                    onSubmit={onFormSubmit}
                >
                    <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="loginIdentifier">
                            {t("ui.account.login")}
                        </label>
                        <div className="uk-form-controls">
                            <input
                                className="uk-input"
                                id="loginIdentifier"
                                name="loginIdentifier"
                                type="text"
                                placeholder={t("ui.account.nick_login")}
                            />
                        </div>
                    </div>

                    <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="loginPassword">
                            {t("ui.account.password")}
                        </label>
                        <div className="uk-form-controls">
                            <input
                                className="uk-input"
                                id="loginPassword"
                                name="loginPassword"
                                type="password"
                                placeholder={t("ui.account.password")}
                            />
                        </div>
                    </div>

                    <div className="uk-margin uk-grid-small uk-child-width-auto" data-uk-grid>
                        <label>
                            <input
                                className="uk-checkbox"
                                id="rememberSession"
                                name="rememberSession"
                                type="checkbox"
                            />
                            {t("ui.account.remember")}
                        </label>
                    </div>

                    <div className="uk-margin">
                        <button
                            type="submit"
                            className="uk-button uk-button-primary uk-button-jai"
                        >
                            {t("ui.account.login")}
                        </button>
                    </div>

                    <div className="uk-margin">
                        <p className="uk-text-small">
                            <Link to="/create-account">{t("ui.account.create")}</Link> |{" "}
                            <Link to="/forgot-password">{t("ui.account.p_forgot")}</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AccountLoginForm;
